import { TimeFilterKind } from '@capturi/api-trackers'
import { Speaker } from '@capturi/core'
import { t } from '@lingui/macro'
import { type } from 'arktype'

export const validationSchema = type({
  uid: type.string.optional(),
  name: type.string.moreThanLength(0).configure({
    message: () => t`Please add a name`,
  }),
  tags: 'string>0[]',
  speech: type.object({
    timeFilter: type.object({
      kind: type.valueOf(TimeFilterKind),
    }),
    speakerId: type.valueOf(Speaker),
  }),
})
